export const GOOGLE_CONFIG = {
  GOOGLE_MAP_API_KEY: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  // GEOFENCE_RADIUS: process.env.REACT_APP_GEOFENCE_RADIUS,
  FEEDBACK_URL: process.env.REACT_APP_FEEDBACK_URL,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  GOOGLE_STREET_VIEW_API: 'https://maps.googleapis.com/maps/api/streetview'
};

export const API_URL = process.env.REACT_APP_API_URL;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN

export const MS_CONFIG = {
  redirectUri: process.env.REACT_APP_MICROSOFT_REDRICET_URI,
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_ID,
    authority: process.env.REACT_APP_MICROSOFT_AUTH_AUTHORITY,
  },

  scopes: ["user.read", "profile"],
};
